// Selectors for all interactive elements that can receive keyboard focus
var FOCUSABLE_SELECTORS = 'a[href]:visible, button:visible:not([disabled]), input:visible:not([disabled]), select:visible:not([disabled]), textarea:visible:not([disabled]), [tabindex]:not([tabindex="-1"]):visible';

// Top-level page landmark selectors to hide from screen readers when modal is open
var BACKGROUND_SELECTORS = 'header, main, footer, .isa-header, .isa-main-section, .isa-footer';

// Returns the first focusable element inside the modal.
// Priority: [autofocus] element > first interactive element > modal itself.
function getFirstFocusable($modal) {
    let $focus = $modal.find('[autofocus]:visible').first();
    if($focus.length) return $focus;
    $focus = $modal.find(FOCUSABLE_SELECTORS).first();
    if($focus.length) return $focus;
    return $modal;
}

// Moves focus into the modal after a short delay to allow animations to complete.
function handleModalOpen($modal) {
    setTimeout(function() {
        if($modal.is(':visible')) {
            getFirstFocusable($modal).focus();
        }
    }, 300);
}

// Traps keyboard focus within the modal by wrapping at boundaries.
// Shift+Tab on first element wraps to last; Tab on last element wraps to first.
function trapFocus(e) {
    var $modal = $(e.currentTarget);
    var $focusableElements = $modal.find(FOCUSABLE_SELECTORS);
    if(!$focusableElements.length) return;

    var $firstFocusable = $focusableElements.first();
    var $lastFocusable = $focusableElements.last();

    if(e.shiftKey) {
        // Shift+Tab: wrap from first to last
        if(document.activeElement === $firstFocusable[0]) {
            e.preventDefault();
            $lastFocusable.focus();
        }
    } else {
        // Tab: wrap from last to first
        if(document.activeElement === $lastFocusable[0]) {
            e.preventDefault();
            $firstFocusable.focus();
        }
    }
}

// Sets aria-hidden="true" on background landmarks so screen readers
// cannot access content behind the modal. Preserves any pre-existing aria-hidden.
function hideBackgroundFromScreenReaders($modal) {
    $(BACKGROUND_SELECTORS).not($modal).not($modal.parents()).each(function() {
        var $el = $(this);
        if($el.attr('aria-hidden') === undefined) {
            $el.data('isa-modal-aria-hidden-added', true);
        }
        $el.attr('aria-hidden', 'true');
    });
}

// Removes aria-hidden from background landmarks when modal closes.
// Only removes the attribute if it was added by this script (not pre-existing).
function restoreBackgroundForScreenReaders() {
    $(BACKGROUND_SELECTORS).each(function() {
        var $el = $(this);
        if($el.data('isa-modal-aria-hidden-added')) {
            $el.removeAttr('aria-hidden');
            $el.removeData('isa-modal-aria-hidden-added');
        }
    });
}

// Returns focus to the element that originally triggered the modal.
// Scrolls the trigger into view if it is off-screen.
function returnFocusToTrigger($modal) {
    var trigger = $modal.data('isa-modal-trigger');
    if(trigger && $(trigger).is(':visible')) {
        if(trigger.scrollIntoView) {
            trigger.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
        $(trigger).focus();
    }
    $modal.removeData('isa-modal-trigger');
}

// Closes a modal using the appropriate method based on its type.
// Handles Bootstrap modals, d-none toggled modals, and backdrop-wrapped modals.
function closeModal($modal) {
    // Bootstrap modal — use the standard API
    if($modal.hasClass('modal') && $.fn.modal) {
        $modal.modal('hide');
        return;
    }

    // Non-Bootstrap modal: hide via d-none or display:none
    $modal.addClass('d-none');

    // If the modal is inside a backdrop wrapper, hide that too
    var $backdrop = $modal.closest('.modal-backdrop');
    if($backdrop.length) {
        $backdrop.hide();
    }

    $modal.trigger('closed');
}

// Binds all modal open/close event handlers.
function initEventHandlers() {
    // Modal open handler — listens for Bootstrap and custom open events
    $(document).on('show.bs.modal opened', '.isa-modal', function() {
        var $modal = $(this);

        // Store the element that had focus before modal opened
        $modal.data('isa-modal-trigger', document.activeElement);

        // Bind keyboard handler for focus trapping and Escape to close
        $modal.on('keydown.isaFocusTrap', function(e) {
            if(e.key === 'Tab') {
                trapFocus(e);
            }
            if(e.key === 'Escape') {
                e.preventDefault();
                e.stopPropagation();
                closeModal($modal);
            }
        });

        hideBackgroundFromScreenReaders($modal);
        handleModalOpen($modal);
    });

    // Modal close handler — listens for Bootstrap and custom close events
    $(document).on('hide.bs.modal closed', '.isa-modal', function() {
        var $modal = $(this);
        $modal.off('keydown.isaFocusTrap');
        restoreBackgroundForScreenReaders();
        returnFocusToTrigger($modal);
    });

    // Single document-level observer to detect any .isa-modal becoming visible or hidden.
    // Covers all modal patterns (Bootstrap, d-none toggle, backdrop wrappers) and
    // dynamically loaded modals without needing per-element observers.
    var bodyObserver = new window.MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            var el = mutation.target;
            var $el = $(el);

            // Check if the mutated element is an .isa-modal
            var $modal = $el.hasClass('isa-modal') ? $el : null;

            // Pattern C: mutated element is a backdrop wrapper containing a nested .isa-modal
            if(!$modal && $el.hasClass('modal-backdrop')) {
                $modal = $el.find('.isa-modal').first();
                if(!$modal.length) $modal = null;
            }

            if(!$modal) return;

            // Defer to allow browser reflow after class/style change
            setTimeout(function() {
                if($modal.is(':visible') && !$modal.data('isa-modal-trigger')) {
                    $modal.trigger('opened');
                } else if(!$modal.is(':visible') && $modal.data('isa-modal-trigger')) {
                    // Modal was hidden externally (e.g. .hide() or adding d-none from outside)
                    $modal.trigger('closed');
                }
            }, 0);
        });
    });

    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'], subtree: true });
}

$(function () {
    initEventHandlers();
});
